import { useQuery } from "@tanstack/react-query";

export type InitialVisitBooking = {
  organization: {
    name: string;
    phoneNumber: string;
    timezone: string;
    location: string;
    logoUrl: string;
  };
  agentActive: boolean;
  patient: {
    id: string;
    archived: boolean;
  },
  appointment: {
    name: string;
    duration: number;
    appointmentTypeId: string;
    caseStudyId?: number;
  };
};

type InitialVisitDetailsParams = {
  uniqueId?: string;
  enabled: boolean;
};

export function useInitialVisitDetails({
  uniqueId,
  enabled = true
}: InitialVisitDetailsParams) {
  return useQuery({
    queryKey: ["initial-visit-details", uniqueId],
    queryFn: async () => {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/bookings/initial-visit/info?uniqueId=${uniqueId}`,
        {
          method: "GET"
        }
      );
      if (response.status !== 200) {
        if (
          response.status === 404 ||
          response.status === 400 ||
          response.status === 410
        ) {
          throw new Error((await response.json()).message);
        } else {
          throw new Error("Error loading appointment details");
        }
      }
      return response.json();
    },
    retry: false,
    staleTime: 1000 * 60 * 60, // cache for 1 hour
    enabled
  });
}
